module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0003.jpg?v=6e755e6d";